import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AddAddressbookComponent } from 'src/app/components/setup/general/addressbook/add/addaddressbook.component';
import { EditAddressbookComponent } from 'src/app/components/setup/general/addressbook/edit/editaddressbook.component';
import { ListAddressbookComponent } from 'src/app/components/setup/general/addressbook/list/listaddressbook.component';

const routes: Routes = [
  { path: 'addressbook', component: ListAddressbookComponent },
  { path: 'addressbook/add', component: AddAddressbookComponent },
  { path: 'addressbook/edit/:id', component: EditAddressbookComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GeneralRoutingModule { }
